/**
 * @flow
 * @relayHash 1ee300ac9d5b2ac5199d1645ad9a68a5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type tradePromoRule_QueryVariables = {|
  userId: string
|};
export type tradePromoRule_QueryResponse = {|
  +viewer: ?{|
    +user: ?{|
      +tradeFirm: ?{|
        +rewards: ?{|
          +currentPromoSegment: ?{|
            +segmentCode: ?string,
            +promotion: ?{|
              +code: ?string
            |},
          |}
        |}
      |}
    |}
  |}
|};
export type tradePromoRule_Query = {|
  variables: tradePromoRule_QueryVariables,
  response: tradePromoRule_QueryResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String"
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "segmentCode",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "tradePromoRule_Query",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tradeFirm",
                "storageKey": null,
                "args": null,
                "concreteType": "TradeFirmType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "rewards",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TradeFirmRewards",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "currentPromoSegment",
                        "storageKey": null,
                        "args": (v2/*: any*/),
                        "concreteType": "currentPromoSegmentType",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "promotion",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Promotion",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "tradePromoRule_Query",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tradeFirm",
                "storageKey": null,
                "args": null,
                "concreteType": "TradeFirmType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "rewards",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TradeFirmRewards",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "currentPromoSegment",
                        "storageKey": null,
                        "args": (v2/*: any*/),
                        "concreteType": "currentPromoSegmentType",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "promotion",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Promotion",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v5/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v5/*: any*/)
                ]
              },
              (v5/*: any*/)
            ]
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "tradePromoRule_Query",
    "id": "dibs-buyer-layout/213.2.1-2019-04-23T05:41:12.419Z/tradePromoRule_Query",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd85cb971657e2814969d3e76333bbf8d';
module.exports = node;
